export const SIMPublicationStatus = {
  Current: "Current",
  Superseded: "Superseded",
  Withdrawn: "Withdrawn",
  AvailableSuperseded: "Available Superseded",
  PendingRevision: "Pending Revision",
  Obsolescent: "Obsolescent"
}
